import React from "react";
import "../styles/notFound.css";
import { Link } from "react-router-dom";
import { DoorOpen } from "lucide-react";
import Astronaut from "../assets/icons/astronaut.svg";
import Planet from "../assets/icons/planet.svg";
import SmallPlanet from "../assets/icons/small-planet.svg";
import Moon from "../assets/icons/moon.svg";

const NotFound404: React.FC = () => {
  return (
    <div className="not-found-container">
      <div className="not-found-title-container">
        <div className="not-found-title">
          <h1>Chà chà!</h1>
          <p className="not-found-message">
            Có vẻ như bạn đã bị lạc vào một khu vực không xác định, hãy thử quay
            về trang chủ nhé!
          </p>
        </div>
        <Link to="/" className="home-link">
          <DoorOpen size={20} /> Trở về trang chủ
        </Link>
      </div>
      <div className="illustration-container">
        <img src={Astronaut} alt="Astronaut" className="astronaut" />
        <img src={Planet} alt="Planet" className="planet" />
        <img src={Moon} alt="Moon" className="moon" />
        <img src={SmallPlanet} alt="Small Planet" className="small-planet" />
      </div>
    </div>
  );
};

export default NotFound404;
